// extracted by css-extract-rspack-plugin
var _1 = "on";
var _2 = "oo";
export { _1 as "confirmationModalComponent", _2 as "confirmationText" }
